
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalShow: false,
      screenWidth: 0,
    }
  },
  mounted() {
    if (localStorage.getItem('isAcceptedAged') == null) {
      //   localStorage.setItem('isAcceptedAge', 'ok');
      this.modalShow = true
    }
    this.updateScreenWidth()
    this.onScreenResize()
  },
  methods: {
    acceptAge() {
      this.modalShow = false
      localStorage.setItem('isAcceptedAged', 'ok')
    },
    onScreenResize() {
      window.addEventListener('resize', () => {
        this.updateScreenWidth()
      })
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth
    },
  },
}
